{
  "book": {
    "brand": "Smart Word Labs",
    "breadcrumb": "预约免费测评",
    "errors": {
      "generic": "无法预约您的测评"
    },
    "success": {
      "title": "测评已预约！",
      "body": "请查看您的电子邮箱以获取确认信息和登录详情。我们已向以下邮箱发送了一个安全登录链接",
      "bodyEnd": "这样您无需密码即可访问家长门户。",
      "backHome": "返回首页"
    },
    "form": {
      "title": "预约您的免费测评",
      "subtitle": "不到一分钟即可完成。无需账户或支付信息——我们会为您设置家长门户。",
      "parentName": "家长姓名",
      "parentEmail": "家长邮箱",
      "childName": "孩子姓名",
      "childAge": "孩子年龄",
      "date": "首选日期",
      "time": "首选时间",
      "booking": "预约中…",
      "submit": "预约免费测评",
      "alreadyEnrolled": "已经报名了？",
      "parentSignIn": "家长登录",
      "localTimeNote": "时间以您所在时区显示"
    }
  },
  "checkout": {
    "title": "安全结算",
    "summary": "{{name}} — 每月 ${{monthly}}，{{lessons}}。可随时取消。",
    "couldNotStart": "无法启动结算流程",
    "choosePlan": {
      "before": "请在",
      "link": "定价页面",
      "after": "选择一个套餐以继续。"
    },
    "summaryOneTime": "{{name}} — 一次性 {{monthly}} 美元，{{lessons}}。"
  },
  "contact": {
    "breadcrumb": "联系我们",
    "title": "联系我们",
    "subtitle": "请使用下方表单，我们将在一个工作日内亲自回复您。",
    "eyebrow": "与我们交流",
    "heading": "对孩子的英语学习有疑问吗？",
    "description": "发送消息，Salma 老师会亲自回复您。如果您更喜欢语音留言或通话而非邮件，请留下您的 WhatsApp 号码。",
    "bullets": {
      "email": "我们会在一个工作日内（周一至周六）通过邮件回复。",
      "whatsapp": "更喜欢 WhatsApp？留下您的号码，我们会在那里给您发消息。"
    },
    "form": {
      "name": "家长姓名",
      "email": "电子邮箱",
      "whatsapp": "WhatsApp 号码（可选）",
      "dialCodeAria": "国家区号",
      "whatsappPlaceholder": "300 1234567",
      "childAge": "孩子年龄（可选）",
      "childAgePlaceholder": "例如：7",
      "subject": "主题（可选）",
      "subjectPlaceholder": "课程时间、价格、测评…",
      "message": "留言",
      "sending": "发送中…",
      "pleaseWait": "请等待 {{seconds}} 秒…",
      "send": "发送消息",
      "sentTitle": "已收到消息",
      "sentBody": "谢谢——我们已收到您的信息，会尽快与您联系。",
      "sendAnother": "发送另一条消息",
      "privacyBefore": "我们仅使用您的信息来回复此咨询。请参阅我们的",
      "privacyLink": "隐私声明",
      "success": "消息已发送——我们将在一个工作日内回复。",
      "validation": {
        "nameRequired": "请输入您的姓名",
        "emailInvalid": "请输入有效的电子邮箱地址",
        "whatsappTooLong": "WhatsApp 号码过长",
        "whatsappFormat": "仅可使用数字、空格、+ 或 -",
        "messageTooShort": "请告诉我们更多信息"
      },
      "errors": {
        "tooFast": "太快了！请稍等片刻再试一次。",
        "checkForm": "请检查表单内容",
        "captcha": "我们无法验证此次提交。请重试。",
        "sendFailed": "我们无法发送您的消息。请重试。"
      }
    }
  },
  "howItWorks": {
    "breadcrumb": "运作方式",
    "hero": {
      "title": "我们的在线英语课程如何运作",
      "subtitle": "小班授课，大幅提升口语自信。每个孩子都会依据 CEFR 标准接受测评、分班和跟踪，并在不超过五人的小组中进行实时授课。"
    },
    "pillars": {
      "title": "我们的三大教学理念"
    },
    "steps": {
      "title": "从咨询到第一堂课"
    },
    "cta": {
      "book": "预约免费测评",
      "browsePrograms": "按年龄浏览课程",
      "seePricing": "查看价格"
    }
  },
  "pricing": {
    "breadcrumb": "价格",
    "compareLink": "不确定选哪个级别？比较各课程"
  },
  "paymentBanner": {
    "notConfigured": "生产环境的结算功能尚未配置。请完成支付上线设置以接受实际付款。",
    "testMode": "预览中的所有付款均为测试模式。",
    "testModeLink": "查看支付测试模式文档",
    "notReady": "实际支付尚未完全就绪：{{failures}}。系统将自动重新检查。"
  },
  "faq": {
    "title": "家长常见问题",
    "subtitle": "关于免费测评、技术、时间安排、付款、分班和退款的详细解答。",
    "items": [
      {
        "q": "免费测评真的是免费的吗？测评中会做什么？",
        "a": "是的——第一堂课是与 Salma 老师进行的完全免费的 20-30 分钟测评，无需提供任何银行卡信息。您的孩子会聊天、阅读并完成一个简短的口语任务，Salma 老师会依据 CEFR 等级对其进行评估。您将在一个工作日内收到书面学习计划和推荐的班级。之后没有任何报名的义务。"
      },
      {
        "q": "我们需要什么设备和网速？",
        "a": "配备摄像头且网络连接稳定（约 5 Mbps）的笔记本电脑、台式机或平板电脑即可——课程通过浏览器在 Zoom 上进行，无需安装其他任何软件。带麦克风的耳机对年幼的孩子有很大帮助，安静明亮的环境也能帮助他们集中注意力。手机在紧急情况下可以使用，但屏幕对于共同阅读任务来说太小了。"
      },
      {
        "q": "我们如何重新安排或取消课程？",
        "a": "请至少在课前 12 小时通过家长门户重新安排课程。每个套餐都包含改期额度（Starter 2 次，Intensive 4 次，Private 无限次）。超出额度后，我们会尝试在当周将您的孩子安排到同一级别的另一个班级，且不收取额外费用；如果没有合适的班级，老师会发送录制的补课任务，并在下一堂课中弥补进度。"
      },
      {
        "q": "你们接受哪些付款方式？安全吗？",
        "a": "套餐通过 Stripe 按月以美元计费，Stripe 支持 Visa、Mastercard、American Express、Apple Pay、Google Pay 以及大多数本地银行卡网络。我们绝不会看到或存储您的银行卡号码——所有信息均在 Stripe 符合 PCI 标准的结算页面中处理。您可以随时通过家长门户更新银行卡信息或取消订阅，取消操作只会停止下一次续订。"
      },
      {
        "q": "我的孩子如何被分配到合适的年龄组和级别？",
        "a": "分班首先依据 CEFR 等级，其次考虑年龄段，因此自信的六岁孩子不会被拖慢，而较为安静的九岁孩子也不会感到不知所措。免费测评能确定孩子的等级；随后年龄段（4-6 岁的早期拼读探索者、7-9 岁的读写能力建设者、10-12 岁的自信沟通者）决定教学节奏、教材和课程时长。如果孩子在学期中超出所在班级的水平，我们会免费将其调整到更高级别。"
      },
      {
        "q": "你们的退款政策是什么？",
        "a": "如果您的孩子在第一个付费月后不满意，请在首次扣费的 14 天内发送邮件给我们，我们将全额退款。此后，取消操作会停止下一次续订，您可以继续使用已付费的所有课程直到本计费月结束——我们不收取取消费用。完整详情请参阅我们的退款政策。"
      },
      {
        "q": "我如何知道孩子在进步？",
        "a": "每个孩子在开始时都会按照 CEFR 等级进行评估。您每月都会收到一份书面进度报告；如果进度慢于计划，Ms. Salma 会调整学习计划并与您沟通。"
      }
    ]
  },
  "faculty": {
    "title": "认识您的老师",
    "subtitle": "每堂课均由 Salma 老师授课，她是持有 CELTA 认证的青少儿英语专家，遵循我们与 CEFR 标准接轨的课程体系。",
    "teacher": {
      "name": "Salma 老师",
      "credential": "CELTA 认证（剑桥英语）· 英语与应用心理学学士",
      "experience": "拥有 10 年以上英语教学经验，涵盖从小学到成人的各个阶段，教学足迹遍布加拿大和中东地区",
      "detail": "英式课程早期读写与拼读教学，与 CEFR 标准接轨的课程，雅思（IELTS）及面试辅导。",
      "quote": "拼读教学如果像游戏而非机械训练，孩子才会真正记住。",
      "photoAlt": "Salma 老师，Smart Word Labs 持有 CELTA 认证的英语教师"
    }
  },
  "testimonials": {
    "title": "家长对我们在线英语课程的评价",
    "ratingSummary": "来自 1200 多位经过验证的家长评价，评分 4.9/5",
    "starsAria": "{{rating}} 星（满分 5 星）",
    "prevAria": "上一页评价",
    "nextAria": "下一页评价",
    "pageAria": "显示第 {{page}} 页评价",
    "reviews": [
      {
        "quote": "Aariz 从只会用单词回答问题，到现在能给我们讲述完整的课堂故事。四人小班意味着他必须开口说话——这改变了一切。",
        "name": "Sana M.",
        "childAge": "6岁孩子的家长",
        "location": "阿联酋，迪拜",
        "rating": 5
      },
      {
        "quote": "每月的 CEFR 报告是我第一次真正看到进步，而不只是'她表现不错'这种笼统的说法。物有所值。",
        "name": "Rachel T.",
        "childAge": "9岁孩子的家长",
        "location": "英国，伦敦",
        "rating": 5
      },
      {
        "quote": "我的两个孩子共用一个账户，我可以并排查看他们的课程。改期只需十秒钟。",
        "name": "Ibrahim K.",
        "childAge": "两个孩子的家长，分别7岁和11岁",
        "location": "巴基斯坦，卡拉奇",
        "rating": 5
      },
      {
        "quote": "读写能力建设课程把阅读从一场'战斗'变成了她主动要求的事情。她在学校的写作水平在一个学期内提升了整整一个级别。",
        "name": "Priya N.",
        "childAge": "8岁孩子的家长",
        "location": "新加坡",
        "rating": 5
      },
      {
        "quote": "自信沟通者课程正是我们儿子在升入中学前所需要的——他现在能在餐桌上毫不犹豫地阐述自己的观点。",
        "name": "Marco B.",
        "childAge": "11岁孩子的家长",
        "location": "意大利，米兰",
        "rating": 5
      },
      {
        "quote": "早期拼读课程只有30分钟，非常适合五岁孩子的注意力持续时间。他现在无论走到哪里都会拼读单词。",
        "name": "Hannah L.",
        "childAge": "5岁孩子的家长",
        "location": "英国，曼彻斯特",
        "rating": 5
      },
      {
        "quote": "我们在入学测评前使用了面试准备课程。我们的女儿走进考场时非常放松，并获得了她的首选学校名额。",
        "name": "Elena V.",
        "childAge": "10岁孩子的家长",
        "location": "西班牙，马德里",
        "rating": 5
      },
      {
        "quote": "Salma 老师在两堂课内就发现我儿子是在猜测而不是真正解读单词。学校一年都没人发现这个问题。",
        "name": "Yusuf A.",
        "childAge": "7岁孩子的家长",
        "location": "卡塔尔，多哈",
        "rating": 5
      },
      {
        "quote": "光是免费测评本身就比我们在别处付费试听的课更有用。我们当周就报了名，从未后悔。",
        "name": "Claire D.",
        "childAge": "9岁孩子的家长",
        "location": "加拿大，多伦多",
        "rating": 4
      }
    ]
  },
  "placementQuiz": {
    "eyebrow": "30秒分班测试",
    "title": "30秒找到合适的班级",
    "subtitle": "回答三个简单问题，我们会为您推荐适合孩子的课程。",
    "stepOf": "第 {{current}} 步，共 {{total}} 步",
    "back": "← 返回",
    "recommended": "推荐课程",
    "bookCta": "预约您的免费测评",
    "seeFullProgramme": "查看完整课程",
    "startAgain": "重新开始",
    "reasons": {
      "new": "我们会从发音和简短口语回答开始，让孩子在加快节奏之前先建立自信。",
      "confident": "您的孩子已经准备好进行更长的口语对话，因此课程将侧重于语法结构、词汇和论述能力。",
      "default": "课程在有指导的练习和充分的自主口语练习之间取得平衡。"
    },
    "steps": [
      {
        "key": "age",
        "title": "您孩子多大了？",
        "options": [
          {
            "value": "4-6",
            "label": "4–6 岁"
          },
          {
            "value": "7-9",
            "label": "7–9 岁"
          },
          {
            "value": "10-12",
            "label": "10–12 岁"
          }
        ]
      },
      {
        "key": "goal",
        "title": "目前最重要的是什么？",
        "options": [
          {
            "value": "phonics",
            "label": "阅读与拼读"
          },
          {
            "value": "writing",
            "label": "写作与学校作业"
          },
          {
            "value": "speaking",
            "label": "口语自信"
          },
          {
            "value": "exams",
            "label": "考试与面试"
          }
        ]
      },
      {
        "key": "comfort",
        "title": "您孩子说英语的熟练程度如何？",
        "options": [
          {
            "value": "new",
            "label": "刚刚起步"
          },
          {
            "value": "some",
            "label": "能说几句话"
          },
          {
            "value": "confident",
            "label": "能相当自如地交流"
          }
        ]
      }
    ]
  },
  "cohortTimeConverter": {
    "intro": "Salma 老师在多伦多授课。以下为您所在时区的上课时间：",
    "timezoneLabel": "您的时区",
    "timezonePlaceholder": "选择您的时区",
    "footnote": "时间以您的当地时间显示。具体时段将在免费测评时确认。"
  }
}
